'use strict';

angular.module('listUtils',[])

.factory('ListController', function ()
{
    var defaultOptions = {
        defaultItem: {},
    };

    function ListController(list, options)
    {
        this.selected = null;
        this.list = list;
        this.options = angular.extend(angular.copy(defaultOptions), options);
    }
    function ListControllerPrototype()
    {
        this.addItem = function ()
        {
            var idx = this.list.indexOf(this.selected);
            if (idx === -1) {
                this.list.push(angular.copy(this.options.defaultItem));
            } else {
                this.list.splice(idx + 1, 0, angular.copy(this.options.defaultItem));
            }
        };

        this.selectItem = function (item)
        {
            this.selected = item;
        };

        this.removeItem = function (item)
        {
            var index = this.list.indexOf(item);
            if (index === -1) {
                return;
            }

            this.list.splice(index, 1);
            this.selectColumn(this.list[index]);
        };

        this.selectRelative = function (modifier)
        {
            if (!this.selected) {
                this.selected = this.list[0];
                return;
            }

            var index = this.list.indexOf(this.selected);
            if (index === -1) {
                this.selected = null;
                return;
            }

            index += modifier;
            index = index % this.list.length;
            if (index < 0) {
                index += this.list.length;
            }

            this.selected = this.list[index];
        };
    }

    ListController.prototype = new ListControllerPrototype();

    return ListController;
});
